// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"638654e2","615":"e12e0bf8","738":"7453c917","818":"e12e0bf8","823":"95d60363"}[chunkId] + ".chunk.css";
};